import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { Layout, Flex } from 'antd'
import React from 'react'
import { z } from 'zod'
import { LocaleSwitch } from '../user/components/locale-switch'
import { redirectPath } from '../auth'

export const Route = createFileRoute('/_guest')({
    validateSearch: z.object({
        redirect: z.string().optional().catch(''),
    }),
    beforeLoad: ({ context, search }) => {
        if (context.auth.isAuthenticated) {
            throw redirect({ to: redirectPath(search.redirect) })
        }
    },
    component: GuestComponent,
})

function GuestComponent() {
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Layout.Content>
                <Flex
                    justify="flex-end"
                    className="absolute right-4 top-4 w-full"
                >
                    <LocaleSwitch />
                </Flex>
                <Flex
                    align="center"
                    justify="center"
                    vertical
                    className="min-h-screen w-full px-4 py-16"
                >
                    <Outlet />
                </Flex>
            </Layout.Content>
        </Layout>
    )
}
